export type CurrencyBaseRate =
  | number
  | string
  | { parsedValue?: number | string | null }
  | null
  | undefined;

export class CurrencyConversionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CurrencyConversionError';
  }
}

export function normalizePositiveBaseRate(rate: CurrencyBaseRate, rateName: string): number {
  const rawValue = typeof rate === 'object' && rate !== null ? rate.parsedValue : rate;
  const normalizedRate = typeof rawValue === 'string' ? Number(rawValue) : rawValue;

  if (typeof normalizedRate !== 'number' || !Number.isFinite(normalizedRate) || normalizedRate <= 0) {
    throw new CurrencyConversionError(`La tasa ${rateName} debe ser un número positivo.`);
  }

  return normalizedRate;
}

export function convertCurrencyAmount(
  amount: number,
  sourceBaseRate: CurrencyBaseRate,
  targetBaseRate: CurrencyBaseRate,
  sameCurrency: boolean = false,
): number {
  if (!Number.isFinite(amount)) {
    throw new CurrencyConversionError('El importe a convertir debe ser un número válido.');
  }

  if (sameCurrency) {
    return amount;
  }

  const sourceRate = normalizePositiveBaseRate(sourceBaseRate, 'de origen');
  const targetRate = normalizePositiveBaseRate(targetBaseRate, 'de destino');
  return roundMoney(amount / sourceRate * targetRate);
}

function roundMoney(value: number): number {
  const factor = 10_000;
  const roundedMagnitude = Math.floor(Math.abs(value) * factor + 0.5 + Number.EPSILON);
  return Math.sign(value) * roundedMagnitude / factor;
}
